import { DateHelpers } from './helpers';

import type { DateRange } from 'react-day-picker';

export const parseDateRangeQuery = (
    from: string | null,
    to: string | null,
): DateRange | undefined => {
    const dateRange = {
        from: from ? DateHelpers.parseApiDate(from) : undefined,
        to: to ? DateHelpers.parseApiDate(to) : undefined,
    } satisfies DateRange;

    return dateRange.from ? dateRange : undefined;
};

export const serializeDateRangeQuery = (dateRange?: DateRange) => ({
    from: dateRange?.from ? DateHelpers.formatApiDate(dateRange.from) : null,
    to: dateRange?.to ? DateHelpers.formatApiDate(dateRange.to) : null,
});
